/**
 * Generates a unique feed description by checking against existing feed names.
 * If the default description already exists, appends a number suffix (2), (3), etc.
 */
export const getUniqueFeedDescription = ( defaultDescription: string, existingFeedNames: string[] ): string => {
	let uniqueDescription = defaultDescription
	let counter = 1

	while ( existingFeedNames.includes( uniqueDescription ) ) {
		counter++
		uniqueDescription = `${defaultDescription} (${counter})`
	}

	return uniqueDescription
}

export const DEFAULT_AEMPV2_INTEGRATION_DESCRIPTION = 'AEMP 2.0 Integration'
export const DEFAULT_INTEGRATION_DESCRIPTION = 'Integration'
